"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PACKET_DRAFT = exports.PACKET_TRUSTEE = exports.PACKET_FILING = exports.AMENDMENT = exports.LOCAL_FORMS = exports.SUPPORT_DOCUMENTS = exports.PAY_ADVICES = exports.FORM_122_A = exports.FORM_121 = exports.FORM_108 = exports.FORM_107 = exports.CREDITOR_MATRIX = exports.FORM_106_DEC = exports.FORM_106_SUM = exports.FORM_106_J = exports.ADD_EMPLOYMENT_BUSINESS = exports.FORM_106_I = exports.FORM_106_H = exports.FORM_106_G = exports.FORM_106_EF = exports.FORM_106_D = exports.FORM_106_C = exports.FORM_106_AB = exports.FORM_103 = exports.FORM_101_A = exports.FORM_101 = exports.PETITION = exports.UTILITY = exports.TAX_RETURN_REQUEST = exports.TAX_RETURN = exports.PAY_STUB = exports.PAY_DAY_LOAN = exports.MEDICAL_RECORD = exports.JUDGMENT = exports.ESIGN = exports.CREDIT_REPORT = exports.CERTIFICATE_OF_COUNSELING = exports.CERTIFICATE_OF_COMPLETION = exports.ADDITION = void 0; // Supplements/Uploads

var ADDITION = 'addition';
exports.ADDITION = ADDITION;
var CERTIFICATE_OF_COMPLETION = 'certificateOfCompletion';
exports.CERTIFICATE_OF_COMPLETION = CERTIFICATE_OF_COMPLETION;
var CERTIFICATE_OF_COUNSELING = 'certificateOfCounseling';
exports.CERTIFICATE_OF_COUNSELING = CERTIFICATE_OF_COUNSELING;
var CREDIT_REPORT = 'creditReport';
exports.CREDIT_REPORT = CREDIT_REPORT;
var ESIGN = 'esign';
exports.ESIGN = ESIGN;
var JUDGMENT = 'judgment';
exports.JUDGMENT = JUDGMENT;
var MEDICAL_RECORD = 'medicalRecord';
exports.MEDICAL_RECORD = MEDICAL_RECORD;
var PAY_DAY_LOAN = 'payDayLoan';
exports.PAY_DAY_LOAN = PAY_DAY_LOAN;
var PAY_STUB = 'payStub';
exports.PAY_STUB = PAY_STUB;
var TAX_RETURN = 'taxReturn';
exports.TAX_RETURN = TAX_RETURN;
var TAX_RETURN_REQUEST = 'taxReturnRequest';
exports.TAX_RETURN_REQUEST = TAX_RETURN_REQUEST;
var UTILITY = 'utility'; // Docassemble

exports.UTILITY = UTILITY;
var PETITION = 'petition'; // Deprecate
// Forms/Sections

exports.PETITION = PETITION;
var FORM_101 = 'form101';
exports.FORM_101 = FORM_101;
var FORM_101_A = 'form101A';
exports.FORM_101_A = FORM_101_A;
var FORM_103 = 'form103';
exports.FORM_103 = FORM_103;
var FORM_106_AB = 'form106AB';
exports.FORM_106_AB = FORM_106_AB;
var FORM_106_C = 'form106C';
exports.FORM_106_C = FORM_106_C;
var FORM_106_D = 'form106D';
exports.FORM_106_D = FORM_106_D;
var FORM_106_EF = 'form106EF';
exports.FORM_106_EF = FORM_106_EF;
var FORM_106_G = 'form106G';
exports.FORM_106_G = FORM_106_G;
var FORM_106_H = 'form106H';
exports.FORM_106_H = FORM_106_H;
var FORM_106_I = 'form106I';
exports.FORM_106_I = FORM_106_I;
var ADD_EMPLOYMENT_BUSINESS = 'addEmploymentBusiness';
exports.ADD_EMPLOYMENT_BUSINESS = ADD_EMPLOYMENT_BUSINESS;
var FORM_106_J = 'form106J';
exports.FORM_106_J = FORM_106_J;
var FORM_106_SUM = 'form106Sum';
exports.FORM_106_SUM = FORM_106_SUM;
var FORM_106_DEC = 'form106Dec';
exports.FORM_106_DEC = FORM_106_DEC;
var CREDITOR_MATRIX = 'creditorMatrix';
exports.CREDITOR_MATRIX = CREDITOR_MATRIX;
var FORM_107 = 'form107';
exports.FORM_107 = FORM_107;
var FORM_108 = 'form108';
exports.FORM_108 = FORM_108;
var FORM_121 = 'form121';
exports.FORM_121 = FORM_121;
var FORM_122_A = 'form122A';
exports.FORM_122_A = FORM_122_A;
var PAY_ADVICES = 'payAdvices';
exports.PAY_ADVICES = PAY_ADVICES;
var SUPPORT_DOCUMENTS = 'supportDocuments';
exports.SUPPORT_DOCUMENTS = SUPPORT_DOCUMENTS;
var LOCAL_FORMS = 'localForms'; // Compilations

exports.LOCAL_FORMS = LOCAL_FORMS;
var AMENDMENT = 'amendment';
exports.AMENDMENT = AMENDMENT;
var PACKET_FILING = 'packetFiling';
exports.PACKET_FILING = PACKET_FILING;
var PACKET_TRUSTEE = 'packetTrustee';
exports.PACKET_TRUSTEE = PACKET_TRUSTEE;
var PACKET_DRAFT = 'packetDraft';
exports.PACKET_DRAFT = PACKET_DRAFT;